import { FC, useState } from 'react';
import { MenuItem, Select, SelectChangeEvent } from '@mui/material';
import CampaignMediaType from './CampaignMediaType';
import { useConfirmDialogContext } from '../../hooks/Contexts/ConfirmDialogContext';

const MEDIA_TYPE_OPTIONS = ['Display', 'Online Video', 'Streaming TV', 'Audio'];

interface MediaTypeEditCellProps {
    value: string;
    onSave: (newValue: string) => void;
}

const MediaTypeEditCell: FC<MediaTypeEditCellProps> = ({ value, onSave }) => {
    const { showConfirm } = useConfirmDialogContext();
    const [editing, setEditing] = useState(false);
    const [localValue, setLocalValue] = useState(value);

    const handleDoubleClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        setEditing(true);
    };

    const handleChange = (e: SelectChangeEvent) => {
        const newValue = e.target.value;
        setEditing(false);
        showConfirm({
            title: 'Update Media Type',
            text: `Change media type from "${localValue}" to "${newValue}"?`,
            okText: 'Update',
            onOk: () => {
                setLocalValue(newValue);
                onSave(newValue);
            },
        });
    };

    if (editing) {
        return (
            <Select
                value={localValue}
                onChange={handleChange}
                onClose={() => setEditing(false)}
                size="small"
                open
                onClick={(e) => e.stopPropagation()}
                sx={{ minWidth: 160 }}
            >
                {MEDIA_TYPE_OPTIONS.map((option) => (
                    <MenuItem key={option} value={option}>
                        {option}
                    </MenuItem>
                ))}
            </Select>
        );
    }

    return (
        <div
            onDoubleClick={handleDoubleClick}
            title="Double-click to edit"
            style={{ cursor: 'default', width: '100%', height: '100%', display: 'flex', alignItems: 'center' }}
        >
            <CampaignMediaType value={localValue} />
        </div>
    );
};

export { MEDIA_TYPE_OPTIONS };
export default MediaTypeEditCell;
